import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import { reaction } from 'mobx'
import * as R from 'ramda'
import i18n from 'i18next'
import Form from '../../form/Form'
import Select from '../../form/Select'
import Tooltip from '../../../UniformComponents/Tooltip'
import CheckboxGroup from '../../form/CheckboxGroup'
import TreeviewSelect from '../../form/TreeviewSelect'
import Accordion from '../../ReportV2/components/Accordion'

@observer
class StagedForm extends PureComponent {
    constructor(props) {
        super(props)
        const { store, controls, valueHolder } = props
        const resetFields = controls
            .map((c) => ({
                field: c.name,
                resetNewWidget: c.resetNewWidgetOnChange,
                reset: c.resetStore,
            }))

        resetFields.forEach((f) => {
            reaction(
                () => valueHolder[f.field],
                () => {
                    R.pathOr([], ['resetNewWidget'], f).forEach((r) => { valueHolder[r] = '' })
                    R.pathOr([], ['reset'], f).forEach((r) => { store[r] = [] })
                },
            )
        })
    }

    renderControls = (controlsOverride) => {
        const {
            store, controls, valueHolder, register, unregister,
        } = this.props
        return R.or(controlsOverride, controls.filter((co) => !co.accordionId)).map((c) => {
            if (c.show && !c.show(store)) return null // 0: hide, 1: show disabled, 2: show
            switch (c.type) {
                case 'select': {
                    const flatOptions = c.indentation
                        ? c.options(store).flatMap((o) => (o.options ? o.options : o))
                        : c.options(store)
                    return (
                        <Select
                            cssClass="formControl"
                            classNamePrefix="z10"
                            options={c.options(store)}
                            onBlur={c.onChange}
                            value={c.isMulti ? valueHolder[c.name]?.slice() : flatOptions
                                .find(({ value }) => value === R.pathOr(valueHolder[c.name], [c.name, 'value'], valueHolder)) || null}
                            defaultValue={c.isMulti ? valueHolder[c.name] : R.pathOr(valueHolder[c.name], [c.name, 'value'], valueHolder)}
                            label={(
                                <div className="selectLabel">
                                    {c.label}
                                    {c.tooltipText
                                        ? (
                                            <i className="fa-solid fa-circle-question">
                                                <Tooltip text={c.tooltipText} direction="bottom" />
                                            </i>
                                        )
                                        : null }
                                </div>
                            )}
                            name={c.name}
                            isMandatory={c.isMandatory}
                            showDisabled={c.show && c.show(store) === 1}
                            register={register}
                            unregister={unregister}
                            isMulti={c.isMulti}
                            blurOnClear
                            validate={c.validate}
                            menuPortalTarget={c.menuPortalTarget}
                            styles={c.styles}
                            showNumberSelected={c.showNumberSelected}
                            isLoading={c.loading}
                            indentation={c.indentation}
                        />
                    )
                }
                case 'radio': {
                    return (
                        <CheckboxGroup
                            cssClass="formControl"
                            label={(
                                <div className="selectLabel">
                                    {c.label}
                                    {c.tooltipText
                                        ? (
                                            <i className="fa-solid fa-circle-question">
                                                <Tooltip text={c.tooltipText} direction="bottom" />
                                            </i>
                                        )
                                        : null }
                                </div>
                            )}
                            options={c.options(store)}
                            defaultChecked={typeof R.pathOr([], c.valuePath, store) === 'boolean'
                                ? [R.pathOr(false, c.valuePath, store)]
                                : R.pathOr([], c.valuePath, store)}
                            refreshOnRender
                            radio
                            name={c.name}
                            isMandatory={c.isMandatory}
                            radioValue={R.pathOr('', c.valuePath, store)}
                            onBlur={c.onChange}
                            register={register}
                            unregister={unregister}
                        />
                    )
                }
                case 'treeViewSelect': {
                    return (
                        <TreeviewSelect
                            cssClass="formControl"
                            label={(
                                <div className="selectLabel">
                                    {c.label}
                                    {c.tooltipText
                                        ? (
                                            <i className="fa-solid fa-circle-question">
                                                <Tooltip text={c.tooltipText} direction="bottom" />
                                            </i>
                                        )
                                        : null }
                                </div>
                            )}
                            options={c.options(store)}
                            returnDeepNested
                            name={c.name}
                            isMandatory={c.isMandatory}
                            onBlur={c.onChange}
                            register={register}
                            unregister={unregister}
                            numSelected={valueHolder[c.name].length}
                        />
                    )
                }
                case 'accordion': {
                    return (
                        this.renderAccordion(c)
                    )
                }
                default:
                    return null
            }
        })
    }

    renderAccordion = (control) => {
        const {
            store, controls, valueHolder, register, unregister,
        } = this.props
        return (
            <Accordion
                // height={accordianHeight}
                // style={{ overflow: 'auto' }}
                cssClass="optionsAccordion"
                title={(
                    <div className="title">
                        {control.title}
                    </div>
                )}
                openIcon="fa-regular fa-chevron-up"
                closeIcon="fa-regular fa-chevron-down"
                isOpen={control.isOpen}
                // defaultOpen
                toggleOpen={control.toggleOpen}
            >
                <div className="stagedFormAccordionBody">
                    {this.renderControls(controls.filter((c) => c.accordionId === control.id))}
                </div>
            </Accordion>
        )
    }

    render() {
        return (
            <div className="formContainer">
                <Form>
                    {this.renderControls()}
                </Form>
            </div>
        )
    }
}

export default StagedForm
